import { LayerTypeSelectionSidebarProps } from "../../../types";
import { RelatedOwners } from "../OwnershipSelectionDetailView/Summary/RelatedOwners";
import { useCallback } from "react";
import { feature } from "@turf/helpers";
import { SelectionType } from "src/js/stores/map/store";
import {
  coerceToOwnershipIntersectableGeometry,
  useTitlesWithOwnerNamesQuery,
} from "../hooks/useTitlesWithOwnerNamesQuery";
import { useSelectionSidebarLoading } from "../../../Bundle/useSelectionSidebarLoadingState";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { InfoPopover } from "react-migration/components/InfoPopover";
import { logEventV2, WorkbenchEventName } from "react-migration/lib/util/logEventV2";

export function OwnershipSelectionSidebarUK({
  selection,
  setDetailSelection,
  onLoadingChange,
}: LayerTypeSelectionSidebarProps) {
  const location = coerceToOwnershipIntersectableGeometry(selection.feature?.geometry || null);
  const { titlesWithOwnerNames, loading } = useTitlesWithOwnerNamesQuery(location);

  useSelectionSidebarLoading(onLoadingChange, loading);

  const setSelectedOwner = useCallback(
    (name?: string) => {
      setDetailSelection?.(
        name
          ? {
              id: name,
              type: SelectionType.OWNER,
              feature: feature(location!),
            }
          : undefined
      );
      logEventV2({
        name: WorkbenchEventName.WORKBENCH_CARD_CLICK,
        properties: {
          cardName: "Ownership",
          action: "goTo",
          clickDetail: "Title owner",
        },
      });
    },
    [location, setDetailSelection]
  );

  if (!location) return null;

  if (loading) return null;

  return <RelatedOwners setSelectedOwner={setSelectedOwner} titlesWithOwnerNames={titlesWithOwnerNames} withCard />;
}

export function OwnershipSelectionSidebarHeaderUK() {
  const { t } = useTranslation();
  return (
    <>
      <h1 className="mr-1 text-sm font-medium text-text-base-primary">{t("ownership.react.map.sidebar.title")}</h1>
      <InfoPopover size="xs">{t("ownership.titles_section.title_owners")}</InfoPopover>
    </>
  );
}
